const provinces = [
  {
    name: 'Agrigento',
    value: 'AG',
    region: 'Sicilia'
  },
  {
    name: 'Alessandria',
    value: 'AL',
    region: 'Piemonte'
  },
  {
    name: 'Ancona',
    value: 'AN',
    region: 'Marche'
  },
  {
    name: 'Arezzo',
    value: 'AR',
    region: 'Toscana'
  },
  {
    name: 'Ascoli Piceno',
    value: 'AP',
    region: 'Marche'
  },
  {
    name: 'Asti',
    value: 'AT',
    region: 'Piemonte'
  },
  {
    name: 'Avellino',
    value: 'AV',
    region: 'Campania'
  },
  {
    name: 'Bari',
    value: 'BA',
    region: 'Puglia'
  },
  {
    name: 'Barletta-Andria-Trani',
    value: 'BT',
    region: 'Puglia'
  },
  {
    name: 'Belluno',
    value: 'BL',
    region: 'Veneto'
  },
  {
    name: 'Benevento',
    value: 'BN',
    region: 'Campania'
  },
  {
    name: 'Bergamo',
    value: 'BG',
    region: 'Lombardia'
  },
  {
    name: 'Biella',
    value: 'BI',
    region: 'Piemonte'
  },
  {
    name: 'Bologna',
    value: 'BO',
    region: 'Emilia-Romagna'
  },
  {
    name: 'Bolzano/Bozen',
    value: 'BZ',
    region: 'Trentino-Alto Adige/Südtirol'
  },
  {
    name: 'Brescia',
    value: 'BS',
    region: 'Lombardia'
  },
  {
    name: 'Brindisi',
    value: 'BR',
    region: 'Puglia'
  },
  {
    name: 'Cagliari',
    value: 'CA',
    region: 'Sardegna'
  },
  {
    name: 'Caltanissetta',
    value: 'CL',
    region: 'Sicilia'
  },
  {
    name: 'Campobasso',
    value: 'CB',
    region: 'Molise'
  },
  {
    name: 'Carbonia Iglesias',
    value: 'CI',
    region: 'Sardegna'
  },
  {
    name: 'Caserta',
    value: 'CE',
    region: 'Campania'
  },
  {
    name: 'Catania',
    value: 'CT',
    region: 'Sicilia'
  },
  {
    name: 'Catanzaro',
    value: 'CZ',
    region: 'Calabria'
  },
  {
    name: 'Chieti',
    value: 'CH',
    region: 'Abruzzo'
  },
  {
    name: 'Como',
    value: 'CO',
    region: 'Lombardia'
  },
  {
    name: 'Cosenza',
    value: 'CS',
    region: 'Calabria'
  },
  {
    name: 'Cremona',
    value: 'CR',
    region: 'Lombardia'
  },
  {
    name: 'Crotone',
    value: 'KR',
    region: 'Calabria'
  },
  {
    name: 'Cuneo',
    value: 'CN',
    region: 'Piemonte'
  },
  {
    name: 'Enna',
    value: 'EN',
    region: 'Sicilia'
  },
  {
    name: 'Fermo',
    value: 'FM',
    region: 'Marche'
  },
  {
    name: 'Ferrara',
    value: 'FE',
    region: 'Emilia-Romagna'
  },
  {
    name: 'Firenze',
    value: 'FI',
    region: 'Toscana'
  },
  {
    name: 'Foggia',
    value: 'FG',
    region: 'Puglia'
  },
  {
    name: 'Forlì-Cesena',
    value: 'FC',
    region: 'Emilia-Romagna'
  },
  {
    name: 'Frosinone',
    value: 'FR',
    region: 'Lazio'
  },
  {
    name: 'Genova',
    value: 'GE',
    region: 'Liguria'
  },
  {
    name: 'Gorizia',
    value: 'GO',
    region: 'Friuli-Venezia Giulia'
  },
  {
    name: 'Grosseto',
    value: 'GR',
    region: 'Toscana'
  },
  {
    name: 'Imperia',
    value: 'IM',
    region: 'Liguria'
  },
  {
    name: 'Isernia',
    value: 'IS',
    region: 'Molise'
  },
  {
    name: "L'Aquila",
    value: 'AQ',
    region: 'Abruzzo'
  },
  {
    name: 'La Spezia',
    value: 'SP',
    region: 'Liguria'
  },
  {
    name: 'Latina',
    value: 'LT',
    region: 'Lazio'
  },
  {
    name: 'Lecce',
    value: 'LE',
    region: 'Puglia'
  },
  {
    name: 'Lecco',
    value: 'LC',
    region: 'Lombardia'
  },
  {
    name: 'Livorno',
    value: 'LI',
    region: 'Toscana'
  },
  {
    name: 'Lodi',
    value: 'LO',
    region: 'Lombardia'
  },
  {
    name: 'Lucca',
    value: 'LU',
    region: 'Toscana'
  },
  {
    name: 'Macerata',
    value: 'MC',
    region: 'Marche'
  },
  {
    name: 'Mantova',
    value: 'MN',
    region: 'Lombardia'
  },
  {
    name: 'Massa-Carrara',
    value: 'MS',
    region: 'Toscana'
  },
  {
    name: 'Matera',
    value: 'MT',
    region: 'Basilicata'
  },
  {
    name: 'Medio Campidano',
    value: 'VS',
    region: 'Sardegna'
  },
  {
    name: 'Messina',
    value: 'ME',
    region: 'Sicilia'
  },
  {
    name: 'Milano',
    value: 'MI',
    region: 'Lombardia'
  },
  {
    name: 'Modena',
    value: 'MO',
    region: 'Emilia-Romagna'
  },
  {
    name: 'Monza e della Brianza',
    value: 'MB',
    region: 'Lombardia'
  },
  {
    name: 'Napoli',
    value: 'NA',
    region: 'Campania'
  },
  {
    name: 'Novara',
    value: 'NO',
    region: 'Piemonte'
  },
  {
    name: 'Nuoro',
    value: 'NU',
    region: 'Sardegna'
  },
  {
    name: 'Ogliastra',
    value: 'OG',
    region: 'Sardegna'
  },
  {
    name: 'Olbia-Tempio',
    value: 'OT',
    region: 'Sardegna'
  },
  {
    name: 'Oristano',
    value: 'OR',
    region: 'Sardegna'
  },
  {
    name: 'Padova',
    value: 'PD',
    region: 'Veneto'
  },
  {
    name: 'Palermo',
    value: 'PA',
    region: 'Sicilia'
  },
  {
    name: 'Parma',
    value: 'PR',
    region: 'Emilia-Romagna'
  },
  {
    name: 'Pavia',
    value: 'PV',
    region: 'Lombardia'
  },
  {
    name: 'Perugia',
    value: 'PG',
    region: 'Umbria'
  },
  {
    name: 'Pesaro e Urbino',
    value: 'PU',
    region: 'Marche'
  },
  {
    name: 'Pescara',
    value: 'PE',
    region: 'Abruzzo'
  },
  {
    name: 'Piacenza',
    value: 'PC',
    region: 'Emilia-Romagna'
  },
  {
    name: 'Pisa',
    value: 'PI',
    region: 'Toscana'
  },
  {
    name: 'Pistoia',
    value: 'PT',
    region: 'Toscana'
  },
  {
    name: 'Pordenone',
    value: 'PN',
    region: 'Friuli-Venezia Giulia'
  },
  {
    name: 'Potenza',
    value: 'PZ',
    region: 'Basilicata'
  },
  {
    name: 'Prato',
    value: 'PO',
    region: 'Toscana'
  },
  {
    name: 'Ragusa',
    value: 'RG',
    region: 'Sicilia'
  },
  {
    name: 'Ravenna',
    value: 'RA',
    region: 'Emilia-Romagna'
  },
  {
    name: 'Reggio di Calabria',
    value: 'RC',
    region: 'Calabria'
  },
  {
    name: "Reggio nell'Emilia",
    value: 'RE',
    region: 'Emilia-Romagna'
  },
  {
    name: 'Rieti',
    value: 'RI',
    region: 'Lazio'
  },
  {
    name: 'Rimini',
    value: 'RN',
    region: 'Emilia-Romagna'
  },
  {
    name: 'Roma',
    value: 'RM',
    region: 'Lazio'
  },
  {
    name: 'Rovigo',
    value: 'RO',
    region: 'Veneto'
  },
  {
    name: 'Salerno',
    value: 'SA',
    region: 'Campania'
  },
  {
    name: 'Sassari',
    value: 'SS',
    region: 'Sardegna'
  },
  {
    name: 'Savona',
    value: 'SV',
    region: 'Liguria'
  },
  {
    name: 'Siena',
    value: 'SI',
    region: 'Toscana'
  },
  {
    name: 'Siracusa',
    value: 'SR',
    region: 'Sicilia'
  },
  {
    name: 'Sondrio',
    value: 'SO',
    region: 'Lombardia'
  },
  {
    name: 'Taranto',
    value: 'TA',
    region: 'Puglia'
  },
  {
    name: 'Teramo',
    value: 'TE',
    region: 'Abruzzo'
  },
  {
    name: 'Terni',
    value: 'TR',
    region: 'Umbria'
  },
  {
    name: 'Torino',
    value: 'TO',
    region: 'Piemonte'
  },
  {
    name: 'Trapani',
    value: 'TP',
    region: 'Sicilia'
  },
  {
    name: 'Trento',
    value: 'TN',
    region: 'Trentino-Alto Adige/Südtirol'
  },
  {
    name: 'Treviso',
    value: 'TV',
    region: 'Veneto'
  },
  {
    name: 'Trieste',
    value: 'TS',
    region: 'Friuli-Venezia Giulia'
  },
  {
    name: 'Udine',
    value: 'UD',
    region: 'Friuli-Venezia Giulia'
  },
  {
    name: "Valle d'Aosta/Vallée d'Aoste",
    value: 'AO',
    region: "Valle d'Aosta/Vallée d'Aoste"
  },
  {
    name: 'Varese',
    value: 'VA',
    region: 'Lombardia'
  },
  {
    name: 'Venezia',
    value: 'VE',
    region: 'Veneto'
  },
  {
    name: 'Verbano-Cusio-Ossola',
    value: 'VB',
    region: 'Piemonte'
  },
  {
    name: 'Vercelli',
    value: 'VC',
    region: 'Piemonte'
  },
  {
    name: 'Verona',
    value: 'VR',
    region: 'Veneto'
  },
  {
    name: 'Vibo Valentia',
    value: 'VV',
    region: 'Calabria'
  },
  {
    name: 'Vicenza',
    value: 'VI',
    region: 'Veneto'
  },
  {
    name: 'Viterbo',
    value: 'VT',
    region: 'Lazio'
  }
]

export default provinces;
